const styles = {
  title: {
    p: {
      textTransform: 'uppercase' as const,
    },
  },
}

export default styles
